import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SandboxDrawerComponent } from './components/sandbox-drawer/sandbox-drawer.component';
import { CommonUtilityModule } from '../../internal/common-utility/common-utility.module';
import { DrawingUtilityModule } from '../../internal/drawing-utility/drawing-utility.module';
import { TextbookDrawerModule } from '@textbook-drawer';

@NgModule({
  declarations: [SandboxDrawerComponent],
  exports: [SandboxDrawerComponent],
  imports: [CommonModule, CommonUtilityModule, DrawingUtilityModule, TextbookDrawerModule],
})
export class SandboxDrawerModule {}
